import { Table, Skeleton } from "@mantine/core";

export function TableSkeletonActivityLog({ length = 20 }) {
  const rows = Array.from({ length: length }).map((_, index) => (
    <Table.Tr key={index}>
      {Array.from({ length: 5 }).map((_, colIndex) => (
        <Table.Td key={colIndex}>
          <Skeleton height={22} radius="sm" />{" "}
        </Table.Td>
      ))}
    </Table.Tr>
  ));

  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          {Array.from({ length: 5 }).map((_, colIndex) => (
            <Table.Th key={colIndex}>
              <Skeleton height={16} width="60%" />
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
}
